export enum EnrollmentPropositionTypeEnum {
  NORMAL = 'NORMAL',
  OTO_INDIVIDUAL = 'OTO_INDIVIDUAL'
}
